var render, staticRenderFns
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367e9dba')) {
      api.createRecord('367e9dba', component.options)
    } else {
      api.reload('367e9dba', component.options)
    }
    
  }
}
component.options.__file = "@shared/Charts/Graphs/PieChart.vue"
export default component.exports